module.exports = __webpack_public_path__ + "img/ventla-invite-icon.2902fc0e.svg";